import React from "react";
import { Route, Routes } from "react-router-dom";
import { AnalyticsPage } from "./pages/analytics-page";

const DroneFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AnalyticsPage />}/>
    </Routes>
  );
};

export default DroneFeature;    
